import React, { createContext, useContext, ReactNode } from 'react';
import { useInstructions } from '../hooks/useInstructions';
import { instructions } from '../constants/instructions';

interface InstructionsContextType {
  currentStep: number;
  nextStep: () => void;
  setStep: (step: number) => void;
  onMinify: () => void;
  isMinified: boolean;
  isCompleted: boolean;
}

const InstructionsContext = createContext<InstructionsContextType | undefined>(undefined);

export const InstructionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const instructionsState = useInstructions(1, instructions.length);

  return (
    <InstructionsContext.Provider value={instructionsState}>
      {children}
    </InstructionsContext.Provider>
  );
};

export const useInstructionsContext = () => {
  const context = useContext(InstructionsContext);
  if (context === undefined) {
    throw new Error('useInstructionsContext must be used within an InstructionsProvider');
  }
  return context;
};
